import Const from 'constants';
import {combineReducers} from 'redux';

const defaultState = {
    data: [],
    sportData: [],
};

export function messages(state = defaultState, action) {
    if (action.type === Const.SET_MESSAGES) {
        state = {...state, data: action.data};
    } else if (action.type === Const.SET_SPORT_MESSAGE) {
        state = {...state, sportData: action.data};
    }

    return state;
}

const reducers = {
    messages,
};

export default combineReducers(reducers);
